import { ALPHA_2_ISO_3166, LIVING_SITUATIONS } from 'cpool-constants';
import { z } from 'zod';

import { regex_iso_date } from '../../../utils/regex.utils';
import { schemaInteger } from '../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#wohnsituation

	{
		"anschrift": {
			"strasse": String,
			"hausnummer": String,
			"plz": String,
			"ort": String,
			"wohnhaftSeit": "YYYY-MM-DD"
		},
		"anzahlPersonenImHaushalt": schemaInteger,
		"anzahlPkw": schemaInteger,
		"gemeinsamerHaushalt": true | false,
		"wohnart": "ZUR_MIETE" | "ZUR_UNTERMIETE" | "IM_EIGENEN_HAUS" | "BEI_DEN_ELTERN",
		"voranschrift": {
			"strasse": String,
			"hausnummer": String,
			"plz": String,
			"ort": String,
			"wohnhaftSeit": "YYYY-MM-DD"
		}
	}

*/

export const schemaEuropaceWohnsituation = z.object({
    anschrift: z.optional(
        z.object({
            hausnummer: z.optional(z.string()),
            // land is not documented in the import but in the update of the process
            land: z.optional(z.nativeEnum(ALPHA_2_ISO_3166)),
            ort: z.optional(z.string()),
            plz: z.optional(z.string()),
            strasse: z.optional(z.string()),
            wohnhaftSeit: z.optional(z.string().regex(regex_iso_date)),
        }),
    ),
    anzahlPersonenImHaushalt: z.optional(schemaInteger),
    anzahlPkw: z.optional(schemaInteger),
    gemeinsamerHaushalt: z.optional(z.boolean()),
    voranschrift: z.optional(
        z.object({
            hausnummer: z.optional(z.string()),
            // land is not documented in the import but in the update of the process
            land: z.optional(z.nativeEnum(ALPHA_2_ISO_3166)),
            ort: z.optional(z.string()),
            plz: z.optional(z.string()),
            strasse: z.optional(z.string()),
            wohnhaftSeit: z.optional(z.string().regex(regex_iso_date)),
        }),
    ),
    wohnart: z.optional(z.nativeEnum(LIVING_SITUATIONS)),
});

export type SchemaEuropaceWohnsituation = z.infer<typeof schemaEuropaceWohnsituation>;
